module.exports = __webpack_public_path__ + "static/img/chatbar.4c713f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chatbar.png
// module id = Wk4A
// module chunks = 4